<template>
	<div class="container">
		<div class="page--section__header">
			<div class="columns is-marginless is-flex">
				<div class="column is-paddingless left">
					<img :src="img_type" alt="" style="width: 318px;height: 115px;">
				</div>
				<div class="column is-paddingless right is-flex is-flex-direction-column is-align-items-flex-end">
					<img :src="require('@/assets/img/img-noble-logo.svg')" alt="">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'header_html',
	props: {
		img_type: {
			type: String,
			default:'',
		},
	},
	data() {
		return {}
	},
	mounted() {},
	methods: {}
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page_section_header.vue